import React from "react";
import { Modal } from "react-bootstrap";
import Resources from "../../../types/Resources";
import ChecklistRadioOptions from "../../Common/ChecklistRadioOptions";
import ConstructionPowerChecklistFormState from "../../../types/forms/Permits/Conditions/ConstructionPowerChecklistFormState";

type ConstructionPowerChecklistModalProps = {
    formState: ConstructionPowerChecklistFormState;
    onChange: (fn: (prevValue: ConstructionPowerChecklistFormState) => ConstructionPowerChecklistFormState) => void;
    resources: Resources;
    show: boolean;
    onHide: () => void;
    canManageContent: boolean;
};

function ConstructionPowerChecklistModal({
    formState,
    onChange,
    resources,
    show,
    onHide,
    canManageContent
}: ConstructionPowerChecklistModalProps) {
    function changeHandler(key: keyof ConstructionPowerChecklistFormState, value: any) {
        onChange((prevValue) => {
            const updatedFormState: ConstructionPowerChecklistFormState = {
                ...prevValue,
                [key]: { ...prevValue[key], value }
            };

            return updatedFormState;
        });
    }

    return (
        <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton>
                <h1 className="h5">{resources.get("ConstructionPowerChecklist")}</h1>
            </Modal.Header>
            <Modal.Body>
                <ul className="list-unstyled">
                    <li className="m-2">
                        <ChecklistRadioOptions
                            id="will-cable-be-placed-on-bare-ground"
                            labelText={resources.get("WillCableBePlacedOnBareGround")}
                            onChange={(updatedValue) => changeHandler("willCableBePlacedOnBareGround", updatedValue)}
                            resources={resources}
                            value={formState.willCableBePlacedOnBareGround.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <p>
                            {resources.get("IfYesToPreviousAnswerFollowing")}:
                        </p>
                    </li>
                    <li className="m-2">
                        <ChecklistRadioOptions
                            id="all-junctions-in-tray-or-suspended-above-ground"
                            labelText={resources.get("AllJunctionsInTrayOrSuspendedAboveGround")}
                            onChange={(updatedValue) => changeHandler("allJunctionsInTrayOrSuspendedAboveGround", updatedValue)}
                            resources={resources}
                            value={formState.allJunctionsInTrayOrSuspendedAboveGround.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <ChecklistRadioOptions
                            id="cables-are-without-trip-hazard"
                            labelText={resources.get("CablesAreWithoutTripHazard")}
                            onChange={(updatedValue) => changeHandler("cablesAreWithoutTripHazard", updatedValue)}
                            resources={resources}
                            value={formState.cablesAreWithoutTripHazard.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <ChecklistRadioOptions
                            id="cable-is-in-protection-tube"
                            labelText={resources.get("CableIsInProtectionTube")}
                            onChange={(updatedValue) => changeHandler("cableIsInProtectionTube", updatedValue)}
                            resources={resources}
                            value={formState.cableIsInProtectionTube.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <ChecklistRadioOptions
                            id="cable-goes-over-road-cycle-or-walkway"
                            labelText={resources.get("CableGoesOverRoadCycleOrWalkway")}
                            onChange={(updatedValue) => changeHandler("cableGoesOverRoadCycleOrWalkway", updatedValue)}
                            resources={resources}
                            value={formState.cableGoesOverRoadCycleOrWalkway.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <ChecklistRadioOptions
                            id="is-cable-protected-with-run-over-protection"
                            labelText={resources.get("IsCableProtectedWithRunOverProtection")}
                            onChange={(updatedValue) => changeHandler("isCableProtectedWithRunOverProtection", updatedValue)}
                            resources={resources}
                            value={formState.isCableProtectedWithRunOverProtection.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <ChecklistRadioOptions
                            id="have-signs-warning-for-cable-over-road"
                            labelText={resources.get("HaveSignsWarningForCableOverRoad")}
                            onChange={(updatedValue) => changeHandler("haveSignsWarningForCableOverRoad", updatedValue)}
                            resources={resources}
                            value={formState.haveSignsWarningForCableOverRoad.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                </ul>
            </Modal.Body>
        </Modal>
    );
}

export default ConstructionPowerChecklistModal;
